import { render, staticRenderFns } from "./TransitionResize.vue?vue&type=template&id=c71ecef4&"
import script from "./TransitionResize.vue?vue&type=script&lang=js&"
export * from "./TransitionResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports